const employeeHeadersExcel = [
  {
    label: 'Username',
    key: 'username',
  },
  {
    label: 'Full name',
    key: 'displayName',
  },
  {
    label: 'Email',
    key: 'email',
  },
  {
    label: 'Gender',
    key: 'gender',
  },
  {
    label: 'Phone number',
    key: 'phoneNumber',
  },
  {
    label: 'Image URL',
    key: 'imageUrl',
  },
  {
    label: 'Address',
    key: 'address',
  },
  {
    label: 'Birthday',
    key: 'birthday',
  },
  {
    label: 'Status',
    key: 'isActivated',
  },
];

const lecturerHeadersExcel = [
  {
    label: 'Username',
    key: 'username',
  },
  {
    label: 'Full name',
    key: 'displayName',
  },
  {
    label: 'Email',
    key: 'email',
  },
  {
    label: 'Gender',
    key: 'gender',
  },
  {
    label: 'Phone number',
    key: 'phoneNumber',
  },
  {
    label: 'Image URL',
    key: 'imageUrl',
  },
  {
    label: 'Address',
    key: 'address',
  },
  {
    label: 'Birthday',
    key: 'birthday',
  },
  {
    label: 'Working',
    key: 'isActivated',
  },
];

const studentHeadersExcel = [
  {
    label: 'Full name',
    key: 'displayName',
  },
  {
    label: 'Email',
    key: 'email',
  },
  {
    label: 'Gender',
    key: 'gender',
  },
  {
    label: 'Phone number',
    key: 'phoneNumber',
  },
  {
    label: 'Image',
    key: 'image',
  },
  {
    label: 'Address',
    key: 'address',
  },
  {
    label: 'Birthday',
    key: 'birthday',
  },
  {
    label: 'Status',
    key: 'isActivated',
  },
];

const courseHeadersExcel = [
  {
    label: 'Course name',
    key: 'courseName',
  },
  {
    label: 'Level',
    key: 'level',
  },
  {
    label: 'Type',
    key: 'type',
  },
  {
    label: 'Fee',
    key: 'fee',
  },
  {
    label: 'Description',
    key: 'description',
  },
  {
    label: 'Status',
    key: 'status',
  },
];

const classHeadersExcel = [
  {
    label: 'Class name',
    key: 'className',
  },
  {
    label: 'Course',
    key: 'course',
  },
  {
    label: 'Room',
    key: 'room',
  },
  {
    label: 'Start date',
    key: 'startDate',
  },
  {
    label: 'End date',
    key: 'endDate',
  },
  {
    label: 'Number of Student',
    key: 'numberOfStudent',
  },
];

export {
  employeeHeadersExcel,
  lecturerHeadersExcel,
  studentHeadersExcel,
  courseHeadersExcel,
  classHeadersExcel,
};
